"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Video.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _VideoChat = require('web/components/VideoChat'); var _VideoChat2 = _interopRequireDefault(_VideoChat);



function getUserAgentSpecificStyle () {
  const userAgent = window.navigator.userAgent
  if ((userAgent.match(/iPhone/i) || userAgent.match(/Android/i) || userAgent.match(/iPad/i)) && window.innerWidth < 561) {
    return {
      height: window.innerHeight,
      width: window.innerWidth,
    }
  } else {
    return {}
  }
}

// The app is client-only; these read browser globals, as the class's render did.
const lowerCaseUserAgent = () => navigator.userAgent.toLowerCase()
const openInChromeHref = () => "googlechrome://navigate?url=" + encodeURI(window.location.href + "?retry")

const Video = ({ location, match }) => {
  const [audioOnly, setAudioOnly] = _react.useState.call(void 0, false)

  // This is a mess - we can't really detect when the publisher component can't publish video on android due to an out of date browser, so long as the browser also supports audio fallback
  const ua = lowerCaseUserAgent()
  if (ua.indexOf("android") > -1) {
    const chromeMatch = ua.match(/chrom(e|ium)\/([0-9]+)\./)
    const samsungMatch = ua.match(/samsungbrowser/)
    // Group 2 always matches when chromeMatch does.
    const majorVer = chromeMatch && !samsungMatch ? parseInt(_nullishCoalesce(chromeMatch[2], () => ( '')), 10) : 0

    if (majorVer < 65 && !audioOnly) {
      let errorText = (
        _react2.default.createElement('div', { className: "video-chat-error-page-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}, "We're sorry - BloomText video isn't supported by your browser. Try opening the link in a recently updated version of Google's Chrome browser. You can also choose to continue, but you'll be limited to voice-only calls."

        )
      )
      let chromeOption = (
        _react2.default.createElement('a', { style: { display: "block" }, href: openInChromeHref(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
          , _react2.default.createElement('div', { className: "video-chat-error-page-option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
            , _react2.default.createElement('img', { className: "video-chat-error-page-option-img", src: "/assets/images/video/chrome.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} ), "Open Google Chrome"

          )
        )
      )

      // If it's a retry, it means we already tried to open in chrome from whatever other browser
      const isRetry = location.search.indexOf("retry") > -1
      if (isRetry) {
        errorText = (
          _react2.default.createElement('div', { className: "video-chat-error-page-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "Your current Chrome version ("
                , majorVer, ") is less than the minimum required version 65. Please update Chrome to use BloomText video, or continue with audio only."
          )
        )
        chromeOption = (
          _react2.default.createElement('a', { style: { display: "block" }, href: "https://play.google.com/store/apps/details?id=com.android.chrome", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
            , _react2.default.createElement('div', { className: "video-chat-error-page-option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
              , _react2.default.createElement('img', { className: "video-chat-error-page-option-img", src: "/assets/images/video/chrome.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}} ), "Download Google Chrome"

            )
          )
        )
      }
      return (
        _react2.default.createElement('div', { className: "video-chat-error-page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
          , _react2.default.createElement('img', { className: "video-chat-error-page-img", src: "/assets/images/video/error.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}} )
          ,  errorText 
          , _react2.default.createElement('div', { className: "video-chat-error-page-option-container", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
            ,  chromeOption 
            , _react2.default.createElement('div', { className: "video-chat-error-page-option", onClick: () => setAudioOnly(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
              , _react2.default.createElement('img', { className: "video-chat-error-page-option-img", src: "/assets/images/video/microphone.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}} ), "Continue Audio Only"

            )
          )
        )
      )
    }
  }

  return (
    _react2.default.createElement('div', { className: "video-chat-page", style: getUserAgentSpecificStyle(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      , _react2.default.createElement(_VideoChat2.default, { videoKey: match.params.videoKey, userKey: match.params.userKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}} )
    )
  )
}

exports. default = Video
